import { useNavigate, useLocation } from "react-router-dom";
import { Button, Typography, Space } from "antd";
import { ArrowLeftOutlined, HomeOutlined, WarningOutlined } from "@ant-design/icons";
import styles from "./NotFoundPage.module.css";

const { Title, Text } = Typography;

const NotFoundPage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div className={styles.root}>
      <div className={styles.inner}>

        {/* Icon */}
        <div className={styles.iconWrap}>
          <WarningOutlined className={styles.icon} />
        </div>

        {/* 404 label */}
        <Text className={styles.code}>404</Text>

        {/* Heading */}
        <Title level={3} className={styles.title}>
          Page not found
        </Title>

        {/* Description */}
        <Text className={styles.description}>
          The URL you entered doesn't match any page in this application.
          Please check the address and try again.
        </Text>

        {/* Bad URL display */}
        <div className={styles.urlBox}>
          <Text className={styles.urlLabel}>Requested URL</Text>
          <code className={styles.urlValue}>{location.pathname}</code>
        </div>

        {/* Actions */}
        <Space size={10} wrap className={styles.actions}>
          <Button
            icon={<ArrowLeftOutlined />}
            onClick={() => navigate(-1)}
            size="large"
          >
            Go back
          </Button>
          <Button
            type="primary"
            icon={<HomeOutlined />}
            onClick={() => navigate("/orders/manage", { replace: true })}
            size="large"
          >
            Go to dashboard
          </Button>
        </Space>

      </div>
    </div>
  );
};

export default NotFoundPage;
